module.exports = __webpack_public_path__ + "static/john.15b2f6fc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/john.jpeg
// module id = 468
// module chunks = 35783957827783